import Tables from 'src/class/Tables';
import i18n from 'src/i18n';


const configTable2 = () => {
  const Table = { ...Tables.Table }; 
    Table.tableColumns2 = [
      {
        prop: 'date_save',
        label: i18n.t('common_words.date'),
        minWidth: 100,
        sortable: true,
        align: 'center',
        fixed: true,
      },
      {
        prop: 'farm',
        label: i18n.t('common_words.farm'),
        minWidth: 150,
        sortable: true,
        align: 'center',
        fixed: true,
      },
      {
        prop: 'block',
        label: i18n.t('calibration.block_or_sector'),
        minWidth: 170,
        sortable: true,
        fixed: true,
        align: 'center',
      },
      {
        prop: 'lot',
        label: i18n.t('common_words.allotment'),
        minWidth: 100,
        sortable: true,
        fixed: true,
        align: 'center',
      },
      {
        prop: 'gang',
        label: i18n.t('calibration.lever_gang'),
        minWidth: 150,
        sortable: true,
        fixed: true,
        align: 'center',
      },
      {
        prop: 'week',
        label: i18n.t('common_words.week'),
        minWidth: 100,
        align: 'center',
      },
      {
        prop: 'total_calibrated',
        label: i18n.t('calibration.total_calibrated'),
        minWidth: 150,
        align: 'center',
      },
      {
        prop: 'total_samples',
        label: i18n.t('calibration.total_samples'),
        minWidth: 120,
        align: 'center',
      },
  ];

  const TableSearch = { ...Tables.Search };

  return { Table, TableSearch };
};

export default configTable2;